<!-- @veltra/icons generated sha256:58a491c67e35255f gen:8 source:src/svg/normal/bottom.svg -->
<script setup lang="ts">
defineOptions({ name: 'Bottom' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8.5 2.502v9.584l3.297-3.297a.5.5 0 0 1 .705.007l.008.008c.196.195.186.5-.01.695l-4.284 4.284a.31.31 0 0 1-.433 0L3.5 9.5a.487.487 0 0 1-.002-.703.5.5 0 0 1 .706-.007L7.5 12.086V2.502A.49.49 0 0 1 7.996 2c.276 0 .504.226.504.502"
    />
  </svg>
</template>
